<template>
    <div class="t-lk-modal__content _small">
        <h2 class="t-lk-modal__title">{{ $root.staticText.lk.staffDeleteTitle }}</h2>
        <div class="t-lk-modal__text">{{ $root.staticText.lk.staffDeleteText }}</div>

        <div class="t-profile-child-staff__item _full">
            <div class="t-profile-child-staff__title">
                <div class="t-profile-child-staff__name">{{ props.item.name }}</div>
            </div>
            <div class="t-profile-child-staff__position">{{ props.item.position }}</div>
            <a :href="'mailto:' + props.item.email" class="t-profile-child-staff__email">{{ props.item.email }}</a>
            <a :href="'tel:' + props.item.phone" class="t-profile-child-staff__phone">{{ props.item.phone }}</a>
        </div>

        <div class="t-lk-modal-del__row">
            <div
                class="t-btn _error _lk"
                :class="{ _disabled: disabledBtn }"
                @click="deleteStaff"
            >
                {{ $root.staticText.lk.staffDeleteBtn }}
            </div>
            <div class="t-lk-modal-del__back" @click="modalClose">{{ $root.staticText.lk.back }}</div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapMutations} from "vuex";
    import Vue from "vue";

    export default {
        name: "deleteStaff",
        props: ['props'],
        data() {
            return {
                action: "lk/deleteStaff",
                disabledBtn: false,
            }
        },
        methods: {
            ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),
            ...mapMutations('lk', ['setStaff']),

            deleteStaff() {
                this.disabledBtn = true;
                let fd = new FormData();
                fd.append('id', this.props.item.id);

                Vue.http.post(this.action, fd)
                    .then(response => response.json())
                    .then(data => {
                        this.disabledBtn = false;
                        if (data.success) {
                            if (data.staff) {
                                this.setStaff(data.staff);
                            }

                            this.modalClose();
                            this.modalType_lkSuccessOpen({
                                title: this.$root.staticText.lk.successText,
                                closeBthNone: true
                            });

                        } else {
                            this.openError(data);
                        }
                    })
                    .catch(data => {
                        this.disabledBtn = false;
                        this.openError(data);
                    });
            },
            openError(data) {
                let text = this.$root.staticText.lk.lkErrorText;
                if (data.errors && data.errors.length > 0) {
                    let key = Object.keys(data.errors)[0];
                    if (data.errors[key][0]) {
                        text = data.errors[key][0];
                    }
                }
                this.modalType_lkErrorOpen({
                    title: this.$root.staticText.lk.lkErrorTitle,
                    text: text,
                    closeBthNone: true
                });
            },
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/deleteStaff.vue